import Vue from 'vue';

// Import VueDot styles
import '@cnamts/vue-dot/dist/vue-dot.css';

// Register v-facade directive
import InputFacade from 'vue-input-facade';
Vue.use(InputFacade);
